// extracted by mini-css-extract-plugin
module.exports = {"container":"_3hdk1","button":"_1tgFP","icon":"_1lXOT","text":"GKaFU","title":"_3FLYN","info":"_14qKB"};